"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.MiniCart = void 0;
const react_1 = __importStar(require("react"));
const styled = __importStar(require("./styled"));
const Typography_1 = __importStar(require("../UI/Typography"));
const useOnOutsideClick_1 = require("@/Hooks/useOnOutsideClick");
const ProductCardBlock_1 = __importDefault(require("../Block/Product/ProductCardBlock/ProductCardBlock"));
const Types_1 = require("Types");
const Theme_1 = require("@/Theme");
const cart_1 = require("@/Redux/Actions/cart");
const react_redux_1 = require("react-redux");
const Utils_1 = require("@/Utils");
const cart_2 = require("@/Endpoints/cart");
const Hooks_1 = require("@/Hooks");
const useCommercePermissions_1 = __importDefault(require("../../Hooks/useCommercePermissions"));
const gtmEvents_1 = require("@/DataLayer/gtmEvents");
const types_1 = require("@/DataLayer/types");
const svg_components_1 = require("app/assets/svg-components");
const LIST_NAME = 'Mini Cart';
const MiniCart = ({ isModalOpen, lineItems, summary }) => {
    var _a, _b;
    const containerRef = (0, react_1.useRef)(null);
    const headerRef = (0, react_1.useRef)(null);
    const footerRef = (0, react_1.useRef)(null);
    const { hasCart, cartPage } = (0, react_redux_1.useSelector)((state) => state.header.header);
    const dispatch = (0, react_redux_1.useDispatch)();
    const { t } = (0, Hooks_1.useTranslate)();
    const { canSeePrice } = (0, useCommercePermissions_1.default)(Types_1.VariantTypes.CART_VIEW);
    (0, useOnOutsideClick_1.useOnOutsideClick)(containerRef, () => {
        dispatch((0, cart_1.setIsOpen)(false));
    });
    const onAmountChange = (0, react_1.useCallback)((newAmount, setIsLoading, code) => {
        const item = lineItems.find(item => item.productCode.value == code);
        const modifiedItem = Object.assign(Object.assign({}, item), { quantity: Math.abs(newAmount - item.quantity) });
        if (item.quantity < newAmount) {
            (0, gtmEvents_1.commonDataLayerEvent)([Object.assign({}, modifiedItem)], types_1.EDataLayerEventsNames.ADD_TO_CART, LIST_NAME);
        }
        if (item.quantity > newAmount) {
            (0, gtmEvents_1.commonDataLayerEvent)([Object.assign({}, modifiedItem)], types_1.EDataLayerEventsNames.REMOVE_FROM_CART, LIST_NAME);
        }
        (0, cart_2.setCartAmount)({
            setIsLoading,
            payload: { code, quantity: newAmount },
            dispatch,
            productId: code
        });
    }, [lineItems === null || lineItems === void 0 ? void 0 : lineItems.length, lineItems]);
    return (react_1.default.createElement(styled.Container, { isModalOpen: isModalOpen, ref: containerRef },
        react_1.default.createElement(styled.Header, { ref: headerRef },
            react_1.default.createElement(styled.Title, { type: Typography_1.Types.H5 }, t('/haldex/mini_cart/title')),
            react_1.default.createElement(styled.CloseButton, { "aria-label": t('/haldex/attributes/aria-label/close'), onClick: () => dispatch((0, cart_1.setIsOpen)(false)) },
                react_1.default.createElement(svg_components_1.CrossIcon, { fill: Theme_1.theme.palette.LIGHT_BLACK }))),
        react_1.default.createElement(styled.CartItemsContainer, null, (lineItems === null || lineItems === void 0 ? void 0 : lineItems.length) ? (lineItems.map((el, index) => (react_1.default.createElement(ProductCardBlock_1.default, { key: index, variant: el, type: Types_1.VariantTypes.MINI_CART_VIEW, onAmountChange: onAmountChange, listIndex: index, listName: LIST_NAME })))) : (react_1.default.createElement(styled.EmptyCartTitle, { type: Typography_1.Types.H5 }, t('/haldex/mini_cart/empty')))),
        react_1.default.createElement(styled.CartFooterContainer, { ref: footerRef },
            canSeePrice && (react_1.default.createElement(react_1.default.Fragment, null,
                react_1.default.createElement(styled.ShippingBlock, null,
                    react_1.default.createElement(Typography_1.default, { type: Typography_1.Types.BODY_2 }, t('/haldex/mini_cart/shipping')),
                    react_1.default.createElement(Typography_1.default, { type: Typography_1.Types.BODY_2 }, t('/haldex/mini_cart/shipping_not_calculated'))),
                react_1.default.createElement(styled.TotalPriceBlock, null,
                    react_1.default.createElement(styled.TotalPrice, { type: Typography_1.Types.H5 }, t('/haldex/mini_cart/total')),
                    react_1.default.createElement(styled.TotalPrice, { type: Typography_1.Types.H5 },
                        (0, Utils_1.currencyEncoder)((_a = summary === null || summary === void 0 ? void 0 : summary.totalItemsPrice) === null || _a === void 0 ? void 0 : _a.currencyCode),
                        (0, Utils_1.priceEncoder)((_b = summary === null || summary === void 0 ? void 0 : summary.totalItemsPrice) === null || _b === void 0 ? void 0 : _b.amount))))),
            react_1.default.createElement(styled.InfoBlock, null, hasCart && cartPage && (react_1.default.createElement(styled.GoToCartButton, { variant: Types_1.LinkAsButtonVariants.LAYOUT_BUTTON, href: cartPage, onClick: () => {
                    dispatch((0, cart_1.setIsOpen)(false));
                } }, t('/haldex/mini_cart/checkout')))))));
};
exports.MiniCart = MiniCart;
exports.default = exports.MiniCart;
